export default __webpack_public_path__ + "static/media/supplier-icon.bb6f867a.svg";